export default "__VITE_PUBLIC_ASSET__4301dad7__"